module.exports = __webpack_public_path__ + "static/media/Email-blue.bfafce7a.svg";